import React from "react";
import { Form, Row, Col } from "react-bootstrap";

const TemperatureInput = ({ temperature, onTemperatureChange }) => {
  return (
    <Form.Group as={Row} className="mb-3">
      <Form.Label column sm={4} md={3}>
        Room Temperature
      </Form.Label>
      <Col sm={8} md={4}>
        <div className="d-flex align-items-center">
          <Form.Control
            type="number"
            value={temperature}
            onChange={(e) => onTemperatureChange(Number(e.target.value))}
            min="59"
            max="86"
            step="1"
            required
          />
          <span className="ms-2">°F</span>
        </div>
        <Form.Text className="text-muted">
          Recommended range: 68-78°F (20-26°C)
        </Form.Text>
      </Col>
    </Form.Group>
  );
};

export default TemperatureInput;
